<nav class="navbar">

  <!--- Toggler -->
  <a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
    <i class="fa fa-chevron-left"></i>
  </a>

  <div class="navbar-content">
    <ul class="navbar-nav">

      <!-- Language -->
      <li *ngIf="langue" class="nav-item" ngbDropdown>
        <!-- selected language -->
        <a class="nav-link" ngbDropdownToggle id="languageDropdown" role="button" title="{{langue.code}}">
          <span *ngIf="!loading">
            <img src="{{langue.flag}}" class="wd-lg-20 wd-40 me-1" alt="{{langue.code}}">
            <span class="fw-bold ms-1 me-1 d-none d-md-inline-block">{{langue.name}}</span>
          </span>
          <span *ngIf="loading" class="text-center mx-3">
            <span class="fa fa-globe fa-spin fa-3x" style="color: #8ed2ff"></span>
          </span>
        </a>

        <!-- languages list -->
        <div ngbDropdownMenu aria-labelledby="languageDropdown">
          <div *ngFor="let item of langues">
            <a ngbDropdownItem class="py-2" *ngIf="item.code != langue.code" (click)="selectLanguage(item)" title="{{item.code}}">
              <img src="{{item.flag}}" class="wd-lg-20 wd-40 me-1" alt="{{item.code}}" />
              <span class="ms-1">{{item.name}}</span>
            </a>
          </div>
        </div>
      </li>

      <!-- Credit -->
      <li *ngIf="accessLink() && notif" class="nav-item" ngbDropdown>
        <a class="credit-count nav-link" [notifyMessage]="pulse" [notifyKey]="'pulse'" [notifyClass]="'load'">
          <span class="fw-bold ms-1 me-1 d-none d-md-inline-block" translate>Credits</span>: 
          <span class="badge badge-primary fw-bold ms-1 me-1 d-md-inline-block counter" 
          style="background: white;color: var(--text-color) !important; font-weight: 900 !important; font-size: revert; text-align: center; padding: 5px;">
            {{utilisateur?.credit || 0}}
          </span>
        </a>
      </li>

      <!-- Notifications -->
      <li class="nav-item nav-notifications" ngbDropdown>
        <a id="notificationDropdown" class="nav-link" ngbDropdownToggle>

          <div [notifyMessage]="notif" [notifyKey]="'notif'" [notifyClass]="'ring'">
            <i class="fa fa-bell icon-bell fa-2x"></i>
          </div>
          
          <div *ngIf="notif; else noMessage" [notifyMessage]="notif" [notifyKey]="'notif'" [notifyClass]="'indicator'">
            <div class="circle"></div>
          </div>

          <ng-template #noMessage>
            <div class="empty">
              <div class="circle"></div>
            </div>
          </ng-template>
        </a>

        <!-- list of alerts -->
        <div ngbDropdownMenu class="px-0" aria-labelledby="notificationDropdown" style="box-shadow: 0px 0px 5px #555;">
          <div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
            <p translate>New Notifications</p>
            <span class="badge bg-danger ml-1">{{notif?.length || 0}}</span>
          </div>

          <div *ngFor="let message of notif">

            <!-- received -->
            <div class="p-1" *ngIf="message.depositor_id==utilisateur.id">
              <a [routerLink]="['deals/proposals/table-receivedpropositions']" (click)="false" class="dropdown-item d-flex align-items-center py-2">
                <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-danger me-3">
                  <i class="las la-download text-white"></i>
                </div>
                <div class="flex-grow-1 me-2">
                  <p translate><i class="fa fa-comment-o" style="font-size: large;"></i> from Chat in received proposals</p>
                </div>	
              </a>
            </div>

            <!-- sent -->
            <div class="p-1" *ngIf="message.depositor_id!=utilisateur.id">
              <a [routerLink]="['deals/proposals/table-sentpropositions']" (click)="false" class="dropdown-item d-flex align-items-center py-2">
                <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-success me-3">
                  <i class="las la-upload text-white"></i>
                </div>
                <div class="flex-grow-1 me-2">
                  <p translate><i class="fa fa-comment-o" style="font-size: large;"></i> from Chat in sent proposals</p>
                </div>	
              </a>
            </div>

          </div>
        </div>
      </li>

      <!-- Profile Log -->
      <li *ngIf="utilisateur" class="nav-item nav-profile" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="profileDropdown">
          <button type="button" class="btn btn-default btn-circle p-0">
            <span class="la la-user"></span>
          </button>
        </a>
        <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
          <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
            <div class="text-center">
                <p class="tx-16 fw-bolder">{{utilisateur.first_name}} {{utilisateur.last_name}}</p>
                <p class="{{(!utilisateur.first_name && !utilisateur.last_name)? 'tx-16 fw-bolder' : 'tx-12 text-muted'}}">{{utilisateur.email}}</p>
            </div>
          </div>
          <!-- profile links -->
          <ul class="list-unstyled p-1">

            <li *ngIf="accessLink()" class="dropdown-item py-2" routerLink="/general/informations">
              <a class="d-flex text-body ms-0">
                <i class="las la-id-card me-2 icon-menu"></i>
                <span translate>Informations</span>
              </a>
            </li>

            <li class="dropdown-item py-2" (click)="logout($event)">
              <a href="" class="d-flex text-body ms-0">
                <i class="feather icon-log-out me-2 icon-md"></i>
                <span class="g_id_signout" translate>Log Out</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

    </ul>
  </div>
</nav>